<div [class]="breakPointclass">
  <ngx-charts-bar-vertical-stacked [view]="styles.view" [scheme]="colorScheme" [results]="data"
    [gradient]="styles.gradient" [xAxis]="styles.xAxis" [yAxis]="styles.yAxis" [legend]="styles.legend"
    [showXAxisLabel]="styles.showXAxisLabel" [showYAxisLabel]="styles.showYAxisLabel" [xAxisLabel]="styles.xAxisLabel"
    [yAxisLabel]="styles.yAxisLabel" [legendTitle]="styles.legendTitle" [legendPosition]="styles.legendPosition"
    [animations]="styles.animations" [barPadding]="styles.barPadding" [showGridLines]="styles.showGridLines">
    <ng-template #tooltipTemplate let-model="model">
      <div class="padding-6px">
        <span class="font-size-13px">{{ model?.series }} - {{model?.name}}</span>
        <br>
        <span class="font-size-16px">{{ model?.value }}</span>
    </div>
    </ng-template>
  </ngx-charts-bar-vertical-stacked>
</div>